import React from 'react';
import {
  Grid,
  TextField,
  MenuItem,
  Typography,
  Box,
  Autocomplete,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import FieldGroup from '../FieldGroup';
import { countyDropDownOptions } from '../../data/EnquiryFormFieldsDropDownData';

const CONTACT_TYPE_OPTIONS = ['Private', 'Forester Company', 'Supplier', 'Grower', 'Sawmill', 'Other'];
const ENQUIRY_TYPE_OPTIONS = ['General', 'Timber Purchase', 'Timber Sale'];

export const pillGroupSx = {
  gap: 1,
  flexWrap: 'wrap',
  '& .MuiToggleButton-root': {
    borderRadius: '20px !important',
    px: 2.5,
    py: 0.6,
    fontSize: '0.85rem',
    textTransform: 'none',
    fontWeight: 600,
    border: '1px solid #d0c9bf',
    color: '#6b6558',
    '&.Mui-selected': {
      backgroundColor: '#7a5c3e',
      color: '#fff',
      borderColor: '#7a5c3e',
      '&:hover': { backgroundColor: '#6b4f34' },
    },
  },
};

export const pillLabelSx = {
  fontSize: '0.8rem',
  fontWeight: 600,
  color: '#6b6558',
  mb: 0.75,
};

export default function ContactStep({ form }) {
  const { state, setField, setHomeField } = form;
  const isOtherContactType = state.contactType === 'Other';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {form.isTimberPurchase && (
        <FieldGroup title="What kind of enquiry is this?">
          <Grid item xs={12}>
            <Typography sx={pillLabelSx}>Show</Typography>
            <ToggleButtonGroup
              exclusive
              size="small"
              value={state.typeOfEnquiry}
              onChange={(e, v) => v && setField('typeOfEnquiry', v)}
              sx={pillGroupSx}
            >
              <ToggleButton value="Enquiry">Enquiry</ToggleButton>
              <ToggleButton value="Quick Enquiry">Quick Enquiry</ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        </FieldGroup>
      )}

      <FieldGroup title="Who are we talking to?">
        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth required label="First Name" value={state.firstName}
            onChange={e => setField('firstName', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth label="Last Name" value={state.lastName}
            onChange={e => setField('lastName', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <PhoneInput
            country="ie"
            value={state.phone}
            onChange={p => setField('phone', p)}
            inputStyle={{ width: '100%', height: 40 }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth label="Email" value={state.email}
            onChange={e => setField('email', e.target.value)} />
        </Grid>

        <Grid item xs={12}>
          <Typography sx={pillLabelSx}>Contact Type</Typography>
          <ToggleButtonGroup
            exclusive
            size="small"
            value={state.contactType}
            onChange={(e, v) => v && setField('contactType', v)}
            sx={pillGroupSx}
          >
            {CONTACT_TYPE_OPTIONS.map(o => (
              <ToggleButton key={o} value={o}>
                {o}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </Grid>

        {isOtherContactType && (
          <Grid item xs={12} sm={6}>
            <TextField size="small" fullWidth label="Specify Contact Type"
              value={state.contactTypeOther || ''}
              onChange={e => setField('contactTypeOther', e.target.value)} />
          </Grid>
        )}

        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth label="Company Name" value={state.companyName}
            onChange={e => setField('companyName', e.target.value)} />
        </Grid>

        <Grid item xs={12}>
          <TextField
            size="small"
            fullWidth
            label="Background Info"
            multiline
            rows={3}
            value={state.crmBackgroundInfo}
            onChange={e => setField('crmBackgroundInfo', e.target.value)}
          />
        </Grid>
      </FieldGroup>

      <FieldGroup title="Home address">
        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth label="Address Line 1" value={state.homeAddressLine1}
            onChange={e => setHomeField('homeAddressLine1', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField size="small" fullWidth label="Address Line 2" value={state.homeAddressLine2}
            onChange={e => setHomeField('homeAddressLine2', e.target.value)} />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Autocomplete
            size="small"
            options={countyDropDownOptions}
            value={state.crmAddressCounty}
            onChange={(e, v) => setField('crmAddressCounty', v || '')}
            renderInput={p => <TextField {...p} label="County" />}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField size="small" fullWidth select label="Country"
            value={state.crmAddressCountry}
            onChange={e => setField('crmAddressCountry', e.target.value)}
          >
            {['Ireland', 'United Kingdom'].map(o => (
              <MenuItem key={o} value={o}>{o}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField size="small" fullWidth label="Eircode" value={state.homeZip}
            onChange={e => setHomeField('homeZip', e.target.value)} />
        </Grid>
      </FieldGroup>
    </Box>
  );
}